import React from "react";
import { IoIosArrowForward, IoMdAdd } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import SetElementSidebarReducer, {
  setElement,
} from "../../Redux/SidebarReducer";
import { Link, useLocation } from "react-router-dom";
import { FaList } from "react-icons/fa";
import { MdOutlineList } from "react-icons/md";
const OrderSidbarWithDropDawn = (props) => {
  const { title, show, icon: IconComponent } = props;
  const location = useLocation();

  // Check if the current path matches the dropdown's route
  const isActive = location.pathname.startsWith(
    `/${show.replace(/\s+/g, "-")}`
  );

  const isAddActive = location.pathname === `/Add-Order-By-Service`;

  const isAddByOfferActive =
    location.pathname.startsWith(`/Add-Order-By-Offer`);

  const elementActive = useSelector((state) => state.Sidebar.elementActive);
  const dispatch = useDispatch();
  const handleClick = () => {
    const value = title === elementActive ? "" : title;
    dispatch(setElement(value));
  };

  return (
    <li className=" ">
      <span
        onClick={handleClick}
        className="pr-0 py-[12px]  pl-[25px]  flex hover:text-primary duration-300 relative  items-center cursor-pointer"
      >
        {IconComponent && <IconComponent className={"mr-[20px]"} />}
        {show}
        <IoIosArrowForward
          className={`absolute right-3 duration-300 text-[14px]
        ${elementActive === title ? "rotate-90" : "rotate-0"}    `}
        />
      </span>
      <ul
        className={`text-[15px]  pl-[19px] duration-300 overflow-hidden  ${
          elementActive === title ? "h-[8rem]" : "h-0"
        } `}
      >
        <Link
          to={`/Add-${title.replace(/\s+/g, "-")}-By-Service`}
          color="inherit"
          underline="none"
        >
          <li
            className={`${
              isAddActive
                ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                : "hover:text-primary"
            } pr-0 py-[8px]  pl-[25px] text-center whitespace-nowrap  flex justify-start gap-x-3 items-center`}
          >
            <IoMdAdd />
            <span className=" duration-100 flex  items-center">
              Add {title} By Service
            </span>
          </li>
        </Link>
        <Link
          to={`/Add-${title.replace(/\s+/g, "-")}-By-Offer`}
          color="inherit"
          underline="none"
        >
          <li
            className={`${
              isAddByOfferActive
                ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                : "hover:text-primary"
            } pr-0 py-[8px]  pl-[25px] text-center whitespace-nowrap  flex justify-start gap-x-3 items-center`}
          >
            <IoMdAdd />
            <span className=" duration-100 flex  items-center">
              Add {title} By Offer
            </span>
          </li>
        </Link>
        <Link
          to={`/${show.replace(/\s+/g, "-")}`}
          color="inherit"
          underline="none"
        >
          <li
            className={`${
              isActive
                ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                : "hover:text-primary"
            } pr-0 py-[8px]  pl-[25px] text-center flex justify-start whitespace-nowrap gap-x-3 items-center`}
          >
            <MdOutlineList />
            <span className=" duration-100 flex  items-center">
              {show}
            </span>
          </li>
        </Link>
      </ul>
    </li>
  );
};

export default OrderSidbarWithDropDawn;
